/*
 * @Descripttion: 
 * @Date: 2021-07-02 15:25:06
 * @LastEditors: Lj07
 * @LastEditTime: 2021-08-25 11:11:13
 */
const pro = 'https://mesapi.hfbsoftware.com'
const dev = 'https://testmes.hfbsoftware.com'

const config = {}
config.host = process.env.NODE_ENV === 'production' ? pro : dev
config.mode = process.env.NODE_ENV === 'production' ? 'pro' : 'dev'


export default config


// WEBPACK FOOTER //
// ./src/Config/config.js